import React from 'react';

export default function ShabbatPlanningMessage({ message }) {
  return (
    <div className="chair-lifting-message shabbat-planning-message">
      <strong className="chair-lifting-kicker">{message.shabbatKind}</strong>
      <div className="chair-lifting-title">{message.crfd1_title}</div>
      {message.registrationDeadline && (
        <div className="chair-lifting-locations">{message.registrationDeadline}</div>
      )}
      {message.attendanceText && (
        <strong className="chair-lifting-locations chair-lifting-location">
          {message.attendanceText}
        </strong>
      )}
      {message.classCounts?.length > 0 ? (
        <ul className="shabbat-class-counts" aria-label="נרשמים לפי שיעור">
          {message.classCounts.map(group => (
            <li key={group.key}>
              <span>{group.label}</span>
              <strong>{group.count}</strong>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
